import React from "react";
import styled from 'styled-components';
import CheckboxUnAble from "../../assets/icons/ic-chkboxAble.svg";


function CheckBox({id, onChange, children, checked, className}) {

    return (
        <>
            <CheckBoxes className={className}>
                <label htmlFor={id}>
                    <input
                        id={id}
                        type="checkbox"
                        name={id}
                        value=""
                        onChange={onChange}
                        checked={checked}
                    />
                    <span className="checkmark"><img src={`${CheckboxUnAble}`} alt={"체크박스"}/></span>
                    <span className="desc">{children}</span>
                </label>
            </CheckBoxes>
        </>
    );
}

const CheckBoxes = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    input[type='checkbox'] {
        display: none;
    }

    & label {
        display: flex;
        align-items: center;
        cursor: pointer;

        & .checkmark {
            position: relative;
            display: block;
            width: 16px;
            height: 16px;
            border: 1px solid #b0b0b0;
            border-radius: 2px;
            background-color: #FFF;

            img {
                display: none;
            }
        }

        & .desc {
            margin: 0 0 0 12px;
        }

        & .desc:empty {
            margin: 0;
        }

        & input[type='checkbox']:checked + .checkmark {
            // border: 1px solid #C86733;
            border: none;

            img {
                //border: 1px solid #C86733;
                display: block;
                width: 20px;
                height: 20px;
                object-fit: cover;
            }
        }

        & input[type='checkbox']:disabled + .checkmark {
            border: 1px solid #E0E0E0;
        }

    }
`;

export default CheckBox;